import {
  MEMBERS_LOADER,
  DOWNLOAD_COUNT,
  SET_MEMBERS_DATA,
  SET_MEMBER_DETAIL_DATA,
} from "../actionTypes";

const initialState = {
  loader: false,
  memberDetail: {},
  members: {},
  pageCount: 0,
};

const membersReducer = (state = initialState, action) => {
  switch (action.type) {
    case MEMBERS_LOADER:
      return {
        ...state,
        loader: action.payload,
      };
    case SET_MEMBERS_DATA: {
      return {
        ...state,
        members: action.payload?.members,
        pageCount: action.payload.totalPages,
      };
    }
    case SET_MEMBER_DETAIL_DATA: {
      return {
        ...state,
        memberDetail: action.payload,
      };
    }
    case DOWNLOAD_COUNT: {
      if (action.payload == "fileview") {
        return {
          ...state,
          memberDetail: {
            ...state.memberDetail,
            fileViewCount: (state.memberDetail?.fileViewCount || 0) + 1,
          },
        };
      } else
        return {
          ...state,
          memberDetail: {
            ...state.memberDetail,
            downloadCount: (state.memberDetail?.downloadCount || 0) + 1,
          },
        };
    }
    default:
      return state;
  }
};

export default membersReducer;
